import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Form, Select, Spin, Icon } from "antd";
import ConfirmButton from "components/buttons/ConfirmButton";
import ModalComponent from "components/modalComponent/ModalComponent";
import AuthRender from "../../AuthRender";

const Option = Select.Option;
const FormItem = Form.Item;
const antIcon = <Icon type="loading" style={{ fontSize: 2 }} spin />;
class ModalSectorUsersManagement extends PureComponent {
	state = {
		userIdToAdd: "",
		usersOptions: [],
		usersManagerInSector: [],
	};

	componentDidUpdate(prevProps) {
		if (
			prevProps.usersManagerInAllSectorUsersList !==
			this.props.usersManagerInAllSectorUsersList
		) {
			const usersManagerIdInAllSectorUsersList = this.props.usersManagerInAllSectorUsersList.map(
				user => user._id
			);
			const usersOptions = this.props.managerUsers.filter(
				user => !usersManagerIdInAllSectorUsersList.includes(user._id) && user.role_id > 1
			);

			this.setState({
				usersOptions,
				usersManagerInSector: this.props.usersManagerInAllSectorUsersList,
			});
		}
	}

	handleAddUserToSector = () => {
		const { userIdToAdd, usersManagerInSector, usersOptions } = this.state;
		const { sectorInfos, updateUserSector, managerUsers } = this.props;
		const getUserInfos = managerUsers.filter(user => user._id === userIdToAdd);
		const copyUsersManagerInSector = _.cloneDeep(usersManagerInSector);
		const copyUsersOptions = _.cloneDeep(usersOptions);

		copyUsersManagerInSector.push(getUserInfos[0]);

		if (!_.isEmpty(getUserInfos)) {
			usersOptions.forEach((user, index) => {
				if (user._id === getUserInfos[0]._id) copyUsersOptions.splice(index, 1);
			});

			if (userIdToAdd !== "") {
				updateUserSector(
					{
						status: true,
						userId: userIdToAdd,
						sectorId: sectorInfos.sector_id,
					},
					"sectors"
				);
				this.setState({
					userIdToAdd: "",
					usersManagerInSector: copyUsersManagerInSector,
					usersOptions: copyUsersOptions,
				});
			}
		}
		this.props.form.resetFields();
	};

	handleRemoveUserToSector = userId => {
		const { sectorInfos, updateUserSector } = this.props;
		const { usersManagerInSector, usersOptions } = this.state;
		const copyUsersManagerInSector = _.cloneDeep(usersManagerInSector);
		const copyUsersOptions = _.cloneDeep(usersOptions);

		usersManagerInSector.forEach((user, index) => {
			if (user._id === userId) {
				copyUsersOptions.push(user);
				copyUsersManagerInSector.splice(index, 1);
			}
		});

		const copyUsersOptionsSorted = _.sortBy(copyUsersOptions, "fullName");

		updateUserSector(
			{
				status: false,
				userId,
				sectorId: sectorInfos.sector_id,
			},
			"sectors"
		);
		this.setState({
			usersManagerInSector: copyUsersManagerInSector,
			usersOptions: copyUsersOptionsSorted,
		});
		this.props.form.resetFields();
	};

	render() {
		const {
			showModal,
			closeModal,
			sectorInfos,
			userInfos,
			updateLoading,
		} = this.props;
		const { usersOptions, usersManagerInSector } = this.state;
		const { getFieldDecorator } = this.props.form;

		return (
			<ModalComponent
				title={sectorInfos.sector_label}
				showModal={showModal}
				closeModal={closeModal}
			>
				<AuthRender service={5} access={["modification"]}>
					<Form
						ref={formRef => {
							this.formRef = formRef;
						}}
					>
						<div className="p-al-full p-mrg-bot">
							<FormItem style={{ marginBottom: "0", width: "80%" }}>
								{getFieldDecorator("select", {
									initialValue: "Ajouter un utilisateur",
								})(
									<Select
										placeholder="Ajouter un utilisateur"
										onChange={value => this.setState({ userIdToAdd: value })}
										notFoundContent={"Tous les utilisateurs ont été ajoutés"}
									>
										{!_.isEmpty(usersOptions) &&
											usersOptions.map(user => (
												<Option value={user._id} key={user.fullName}>
													{user.fullName}
												</Option>
											))}
									</Select>
								)}
							</FormItem>
							<ConfirmButton
								label={"Ajouter"}
								large={true}
								onClick={() => this.handleAddUserToSector()}
							/>
						</div>
					</Form>
				</AuthRender>
				<div className="p-modal-scrollcontent">
					{_.sortBy(usersManagerInSector, "fullName").map(user => (
						<div key={user._id} className="p-al-full p-mrg-ver-s">
							<span>{user.fullName}</span>
							{user.role_id !== userInfos.role_id && (
								<AuthRender service={5} access={["modification"]}>
									{updateLoading ? (
										<i style={{ color: "#ddd" }}>Chargement...</i>
									) : (
										<span
											className="icon-close p-cursor-pointer"
											onClick={() => this.handleRemoveUserToSector(user._id)}
										/>
									)}
								</AuthRender>
							)}
						</div>
					))}
				</div>
			</ModalComponent>
		);
	}
}

ModalSectorUsersManagement.propTypes = {
	showModal: PropTypes.boolean,
	closeModal: PropTypes.function,
	// data: PropTypes.array,
	// children? JSX
};

export default Form.create()(ModalSectorUsersManagement);



// WEBPACK FOOTER //
// src/containers/metier/sectors/ModalSectorUsersManagement.js